import { Box, List } from "@mantine/core";
import type { ReactNode } from "react";
import { Extendable } from "../Extendable/Extendable";

export interface TruncatedListProps {
  items: Array<ReactNode>;
  maxVisible?: number;
  /** Renders items as a bulleted <List> instead of plain stacked boxes. */
  bulleted?: boolean;
}

function TruncatedList({
  items,
  maxVisible = 3,
  bulleted = true
}: TruncatedListProps) {
  const visibleItems = items.slice(0, maxVisible);
  const hiddenItems = items.slice(maxVisible);

  const renderItems = (itemsToRender: Array<ReactNode>, keyOffset: number) =>
    bulleted ? (
      <List withPadding>
        {itemsToRender.map((item, i) => (
          <List.Item key={keyOffset + i}>{item}</List.Item>
        ))}
      </List>
    ) : (
      itemsToRender.map((item, i) => <Box key={keyOffset + i}>{item}</Box>)
    );

  return (
    <>
      {renderItems(visibleItems, 0)}
      {hiddenItems.length > 0 && (
        <Extendable>{renderItems(hiddenItems, maxVisible)}</Extendable>
      )}
    </>
  );
}

export { TruncatedList };
